import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  // Resolved during the first render, not after it: this now decides whether
  // a list renders as a table or as cards, and a one-frame desktop table on a
  // phone is a visible flash.
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.innerWidth < MOBILE_BREAKPOINT
      : undefined
  );

  React.useEffect(() => {
    // Test environments (jsdom) have no matchMedia; stay on the desktop
    // default there rather than throwing out of the effect.
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
